import React from "react";
import "./Profile.scss";
import { NavLink, Outlet } from "react-router-dom";

const Profile = () => {
  const handleLogout = () => {
    localStorage.removeItem("user");
  };
  return (
    <>
      <div className="account_page w-[96%]">
        <div className="account_page_container">
          <div className="font-medium text-[28px] text-center py-10">My Profile</div>
          <div className="flex gap-10 items-start py-10 px-3 bg-[#FAFAFA] rounded-sm">
            <div className="account_tabs">
              <div className="tabs_navigation">
                <NavLink
                  to="/profile/account-details"
                  className={({ isActive }) =>
                    isActive ? "tab active" : "tab"
                  }
                >
                  Account details
                </NavLink>
                {/* <NavLink
                  to="/profile/wishlist"
                  className={({ isActive }) =>
                    isActive ? "tab active" : "tab"
                  }
                >
                  Wishlist
                </NavLink> */}
                <NavLink
                  to="/profile/orders"
                  className={({ isActive }) =>
                    isActive ? "tab active" : "tab"
                  }
                >
                  Orders
                </NavLink>
                <NavLink
                  to="/profile/address"
                  className={({ isActive }) =>
                    isActive ? "tab active" : "tab"
                  }
                >
                  Address
                </NavLink>
                <NavLink to={"/"} className="tab" onClick={handleLogout}>
                  Logout
                </NavLink>
              </div>
            </div>

            <>
              <Outlet />
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
